import { memo } from "react";
import { Box, Container, Typography, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { FullPaddingWrapper } from "../../Components/FullPaddingWrapper/FullPaddingWrapper";
import NewspaperIcon from "@mui/icons-material/Newspaper";

const Press = memo(() => {
  const navigate = useNavigate();
  return (
    <Container maxWidth="xl" disableGutters>
      <FullPaddingWrapper>
        {/* Hero Section */}
        <Box
          sx={{
            background: "linear-gradient(135deg, #004B4C 0%, #006668 100%)",
            borderRadius: { xs: "16px", md: "24px" },
            minHeight: { xs: 400, md: 500 },
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
            p: { xs: 4, md: 8 },
            mb: { xs: 4, md: 6 },
          }}
        >
          <Box
            sx={{
              width: { xs: 80, md: 120 },
              height: { xs: 80, md: 120 },
              borderRadius: "50%",
              backgroundColor: "rgba(255, 255, 255, 0.1)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              mb: 4,
            }}
          >
            <NewspaperIcon
              sx={{
                fontSize: { xs: 40, md: 60 },
                color: "#ffffff",
              }}
            />
          </Box>

          <Typography
            variant="h2"
            sx={{
              color: "#ffffff",
              fontWeight: 700,
              fontSize: { xs: "2rem", sm: "2.5rem", md: "3rem" },
              lineHeight: 1.2,
              mb: 2,
            }}
          >
            Press & Media
          </Typography>

          <Typography
            variant="body1"
            sx={{
              color: "#ffffff",
              fontSize: { xs: "1rem", md: "1.2rem" },
              fontWeight: 300,
              lineHeight: 1.6,
              maxWidth: 600,
              opacity: 0.9,
              mb: 4,
            }}
          >
            Stay updated with the latest news, announcements, and media coverage
            about SimplerHome and our mission to transform homeownership.
          </Typography>

          <Box
            sx={{
              backgroundColor: "rgba(255, 255, 255, 0.15)",
              borderRadius: "12px",
              px: { xs: 4, md: 6 },
              py: { xs: 2, md: 3 },
              border: "1px solid rgba(255, 255, 255, 0.2)",
            }}
          >
            <Typography
              variant="h6"
              sx={{
                color: "#ffffff",
                fontWeight: 600,
                fontSize: { xs: "1rem", md: "1.25rem" },
              }}
            >
              Coming Soon
            </Typography>
            <Typography
              variant="body2"
              sx={{
                color: "#ffffff",
                opacity: 0.8,
                mt: 1,
              }}
            >
              Our press room is being prepared. Check back for updates!
            </Typography>
          </Box>
        </Box>

        {/* Media Contact Section */}
        <Box
          sx={{
            py: { xs: 6, md: 10 },
            px: { xs: 2, md: 4 },
            textAlign: "center",
          }}
        >
          <Typography
            variant="h4"
            sx={{
              color: "primary.main",
              fontWeight: 700,
              fontSize: { xs: "1.5rem", md: "2rem" },
              mb: 3,
            }}
          >
            Media Inquiries
          </Typography>

          <Typography
            variant="body1"
            sx={{
              color: "#333",
              fontSize: { xs: "1rem", md: "1.1rem" },
              lineHeight: 1.6,
              maxWidth: 700,
              mx: "auto",
              mb: 6,
            }}
          >
            For press inquiries, interview requests, or media partnerships,
            please reach out to our communications team. We're happy to provide
            information, quotes, and resources about SimplerHome.
          </Typography>

          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: { xs: "1fr", md: "repeat(2, 1fr)" },
              gap: 4,
              maxWidth: 800,
              mx: "auto",
            }}
          >
            <Box
              sx={{
                p: 4,
                borderRadius: "16px",
                backgroundColor: "#f8f8f8",
              }}
            >
              <Typography
                variant="h6"
                sx={{
                  color: "primary.main",
                  fontWeight: 600,
                  mb: 2,
                }}
              >
                Brand Assets
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  color: "#333",
                  lineHeight: 1.6,
                }}
              >
                Download our logos, brand guidelines, and official imagery for
                your publications.
              </Typography>
            </Box>

            <Box
              sx={{
                p: 4,
                borderRadius: "16px",
                backgroundColor: "#f8f8f8",
              }}
            >
              <Typography
                variant="h6"
                sx={{
                  color: "primary.main",
                  fontWeight: 600,
                  mb: 2,
                }}
              >
                Press Releases
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  color: "#333",
                  lineHeight: 1.6,
                }}
              >
                Access our official announcements, product launches, and company
                news.
              </Typography>
            </Box>
          </Box>

          <Button
            variant="contained"
            color="secondary"
            size="large"
            onClick={() => navigate("/contact?topic=press")}
            sx={{
              mt: 8,
              px: { xs: 5, md: 10, lg: 15 },
              py: { xs: 1.5, md: 2, lg: 2.5 },
              fontSize: { xs: "1rem", md: "1.1rem", lg: "1.2rem" },
              fontWeight: 500,
              borderRadius: "8px",
              textTransform: "none",
              color: "#ffffff",
            }}
          >
            Contact Press Team
          </Button>
        </Box>
      </FullPaddingWrapper>
    </Container>
  );
});

export default Press;
